export const fetchGenericEmailTypes = (payload) => {
    return {
        type: "FETCH_GENERIC_EMAIL_TYPES",
        payload
    }
};